import mutations from "@/store/mutations/insUserInfoMutation";
import getters from "@/store/getters/insUserInfoGetter";
import actions from "@/store/actions/insUserInfoAction";
/**
 * [INS] InseUserInfo DATA
 */
export default {
  state: {
    insUserList: []
  },
  mutations,
  getters,
  actions
};
